module.exports = __webpack_public_path__ + "static/media/children-squatting.52372944.PNG";